import type { ParserObject } from "../../policyParserTypes";
import outputDiscord from "./output_discord.json";
import outputGoogle from "./output_google.json";
import outputLinkedIn from "./output_linkedin.json";
import outputMeta from "./output_meta.json";
import outputNetflix from "./output_netflix.json";
import outputTikTok from "./output_tiktok.json";
import outputX from "./output_x.json";

const outputs: Record<string, ParserObject[]> = {
  "discord.com": outputDiscord as ParserObject[],
  "google.com": outputGoogle as ParserObject[],
  "linkedin.com": outputLinkedIn as ParserObject[],
  meta: outputMeta as ParserObject[],
  "netflix.com": outputNetflix as ParserObject[],
  "tiktok.com": outputTikTok as ParserObject[],
  "twitter.com": outputX as ParserObject[],
};

export { outputs };
